export default __webpack_public_path__ + "static/media/sahyog_wellness_multi_function_non_contact_body_object_infrared_thermometer_0_1.6b7ae7d9.dib";